import React from 'react';
import {ProjectBacklogs} from './ProjectBacklogs';
import {AddUserStory} from './AddUserStory';
import {ProjectManagement} from './ProjectManagement';
import {SprintManager} from './SprintManager';
import {TaskManager} from './TaskManager';
import {IssueManager} from './IssueManager';
import {EpicManager} from './EpicManager';
import {ReportManager} from './ReportManager';
import {ViewUserStory} from './ViewStory';
import {
  NativeStackScreenProps,
  createNativeStackNavigator,
} from '@react-navigation/native-stack';
import {RootNavigatorParams, Routes} from 'navigation/Routes';

const ProjectManagementStack = createNativeStackNavigator();

export function ProjectManagementNavigation({
  navigation,
}: NativeStackScreenProps<RootNavigatorParams>) {
  return (
    <ProjectManagementStack.Navigator
      initialRouteName={Routes.PROJECT_MANAGEMENT_INDEX}
      screenOptions={{headerShown: false}}>
      <ProjectManagementStack.Screen name={Routes.PROJECT_MANAGEMENT_INDEX}>
        {props => <ProjectManagement {...props} />}
      </ProjectManagementStack.Screen>

      <ProjectManagementStack.Screen name={Routes.ADD_USER_STORY}>
        {props => <AddUserStory {...props} />}
      </ProjectManagementStack.Screen>

      <ProjectManagementStack.Screen name={Routes.PROJECT_BACKLOGS}>
        {props => <ProjectBacklogs {...props} />}
      </ProjectManagementStack.Screen>

      <ProjectManagementStack.Screen name={Routes.PROJECT_SPRINT}>
        {props => <SprintManager {...props} />}
      </ProjectManagementStack.Screen>

      <ProjectManagementStack.Screen name={Routes.PROJECT_TASK}>
        {props => <TaskManager {...props} />}
      </ProjectManagementStack.Screen>

      <ProjectManagementStack.Screen name={Routes.PROJECT_ISSUES}>
        {props => <IssueManager {...props} />}
      </ProjectManagementStack.Screen>

      <ProjectManagementStack.Screen name={Routes.PROJECT_EPIC}>
        {props => <EpicManager {...props} />}
      </ProjectManagementStack.Screen>

      <ProjectManagementStack.Screen name={Routes.PROJECT_REPORT}>
        {props => <ReportManager {...props} />}
      </ProjectManagementStack.Screen>

      <ProjectManagementStack.Screen name={Routes.VIEW_USER_STORY}>
        {props => <ViewUserStory {...props} />}
      </ProjectManagementStack.Screen>
    </ProjectManagementStack.Navigator>
  );
}
